import * as ContactUsFeaturesUploads from "$lib/data/generated/uploads/contact us/Features/uploads.js";
import * as ContactUsFormUploads from "$lib/data/generated/uploads/contact us/Form/uploads.js";
import * as ContactUsHeadUploads from "$lib/data/generated/uploads/contact us/Head/uploads.js";
import * as ContactUsPageBannerUploads from "$lib/data/generated/uploads/contact us/PageBanner/uploads.js";

export const uploads = {
  ...ContactUsFeaturesUploads.uploads,
  ...ContactUsFormUploads.uploads,
  ...ContactUsHeadUploads.uploads,
  ...ContactUsPageBannerUploads.uploads
};
